import { ApiService } from '~lib/helpers/api'

export const logout = async (): Promise<void> => {
  return ApiService.post('/auth/logout')
}
